import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import Input from '../../../../components/Input';
import RadioButton from '../../../../components/RadioButton';
import { useDispatch, useSelector } from '../../../../store/store';
import { removeEducationInfo, updateEducationInfo } from '../../../../store/signUp/slice';
import { EducationInfo, ListItem } from '../../../../store/signUp/types';
import styles from './style.module.scss';
import { fromDatePickerFormat, toDatePickerFormat } from '../../../../utils/dateHelpers';
import DropDown from '../../../../components/DropDown';
import { degreeList } from '../../../../config';
import { errorMessages } from '../../../../config/notification';
import { useEffect, useState } from 'react';
import { selectUniversities } from '../../../../store/signUp/selectors';
import { getUniversitiesThunk } from '../../../../store/signUp/thunks';

interface Props {
    data: EducationInfo;
};

function EducationForm(props: Props) {
    const [dateRangeError, setDateRangeError] = useState(false);
    const universities = useSelector(selectUniversities);

    const {
        id,
        to,
        GPA,
        from,
        field,
        degree,
        universityName,
        didNotFinishDegree,
    } = props.data;

    const dispatch = useDispatch();

    useEffect(() => {
        universityName.length > 3 && dispatch(getUniversitiesThunk(universityName));
    }, [universityName]);

    const updateForm = (key: keyof EducationInfo, value: any) => {
        let newForm = { ...props.data };

        switch (key) {
            case 'from': {
                const formatedDate = fromDatePickerFormat(value);
                newForm = { ...newForm, [key]: formatedDate };
                const check = new Date(formatedDate) > new Date(to);
                setDateRangeError(check);
                break;
            }
            case 'to': {
                const formatedDate = fromDatePickerFormat(value);
                newForm = { ...newForm, [key]: formatedDate }
                const check = new Date(formatedDate) < new Date(from)
                setDateRangeError(check);
                break;
            }
            case 'didNotFinishDegree':
                newForm = { ...newForm, [key]: value, to: "" };
                break;
            default:
                newForm = { ...newForm, [key]: value };
                break;
        }

        dispatch(updateEducationInfo(newForm));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.row}>
                <Input
                    isRequired
                    listShow
                    type='text'
                    label='School or university'
                    value={universityName}
                    list={universities}
                    listIdKey='id'
                    listTitleKey='title'
                    onChange={(val: string) => updateForm('universityName', val)}
                    onItemClick={(item: ListItem) => updateForm('universityName', item.title)}
                />
                <DropDown
                    isRequired
                    label='Degree'
                    dropDownList={degreeList}
                    selectedItem={degreeList.find(i => i.title === degree)}
                    setItem={(item: ListItem) => updateForm('degree', item.title)}
                    titleKey='title'
                    idKey='id'
                />
            </div>

            <div className={styles.row}>
                <Input
                    isRequired
                    type='text'
                    label='Field of study'
                    value={field}
                    onChange={(val: string) => updateForm('field', val)}
                />
                <Input
                    isRequired
                    type='text'
                    value={`${GPA}`}
                    validation='GPA'
                    inputMode='numeric'
                    label='Overal result (GPA)'
                    onChange={(val: string) => updateForm('GPA', val)}
                />
            </div>

            <div className={styles.date}>
                <div className={styles.date_fromTo}>
                    <DatePicker
                        isRequired
                        label='From'
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(from)}
                        setSelectedDate={(val) => updateForm('from', val)}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />
                    {!didNotFinishDegree && <DatePicker
                        label='To'
                        isRequired
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(to)}
                        setSelectedDate={(val) => updateForm('to', val)}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />}
                </div>
                {dateRangeError && (<span className={styles.date_error}>{errorMessages.dateRange}</span>)}
                <RadioButton
                    text="Didn’t finish the degree"
                    checked={didNotFinishDegree}
                    setChecked={(val) => updateForm('didNotFinishDegree', val)}
                />
            </div>
            {id !== 'initial-record' && (<Button
                type='Error'
                text='Delete degree'
                className={styles.delete}
                onClick={() => dispatch(removeEducationInfo(id))}
            />)}
        </div>
    );
};

export default EducationForm;
